export const CAREER = [
  { key: '1', value: '1년 이하' },
  { key: '2', value: '2년' },
  { key: '3', value: '3년' },
  { key: '4', value: '4년' },
  { key: '5', value: '5년' },
  { key: '6', value: '6년' },
  { key: '7', value: '7년' },
  { key: '8', value: '8년' },
  { key: '9', value: '9년' },
  { key: '10', value: '10년' },
  { key: '11', value: '11년' },
  { key: '12', value: '12년' },
  { key: '13', value: '13년' },
  { key: '14', value: '14년' },
  { key: '15', value: '15년' },
  { key: '16', value: '16년' },
  { key: '17', value: '17년' },
  { key: '18', value: '18년' },
  { key: '19', value: '19년' },
  { key: '20', value: '20년 이상' },
];
